export var Capability;
(function (Capability) {
    Capability["GET_PROFILES"] = "GET_PROFILES";
    Capability["UPDATE_PROFILES"] = "UPDATE_PROFILES";
    Capability["GET_RESERVATIONS"] = "GET_RESERVATIONS";
    Capability["UPDATE_RESERVATIONS"] = "UPDATE_RESERVATIONS";
    Capability["GET_RESOURCES"] = "GET_RESOURCES";
    Capability["UPDATE_RESOURCES"] = "UPDATE_RESOURCES";
    Capability["GET_SERVICES"] = "GET_SERVICES";
    Capability["UPDATE_SERVICES"] = "UPDATE_SERVICES";
    Capability["GET_INVOICES"] = "GET_INVOICES";
    Capability["UPDATE_INVOICES"] = "UPDATE_INVOICES";
    Capability["GET_CONTENT"] = "GET_CONTENT";
    Capability["UPDATE_CONTENT"] = "UPDATE_CONTENT";
    Capability["PAYMENTS_REGULAR"] = "PAYMENTS_REGULAR";
    Capability["ROOM_BILLING"] = "ROOM_BILLING";
    Capability["SEND_EMAIL"] = "SEND_EMAIL";
    Capability["SEND_SMS"] = "SEND_SMS";
})(Capability || (Capability = {}));
export var AppCategory;
(function (AppCategory) {
    AppCategory["APP"] = "APP";
    AppCategory["INTEGRATION"] = "INTEGRATION";
})(AppCategory || (AppCategory = {}));
